import type { ReactNode } from "react";

import { usePermissions } from "@/hooks/use-permissions";

interface CanProps {
	/** Permissions requises (ET logique) */
	permission?: string | string[];
	/** Au moins une de ces permissions (OU logique) */
	anyOf?: string[];
	/** Fallback à afficher si la condition n'est pas remplie (par défaut : rien) */
	fallback?: ReactNode;
	children: ReactNode;
}

export function Can({
	permission,
	anyOf,
	fallback = null,
	children,
}: CanProps) {
	const { has, hasAny } = usePermissions();
	const required = permission
		? Array.isArray(permission)
			? permission
			: [permission]
		: [];

	const allowed =
		(required.length === 0 || has(...required)) && (!anyOf || hasAny(...anyOf));

	return <>{allowed ? children : fallback}</>;
}
